import {UpperCasePipe} from "@angular/common"
import {Component, input, OnDestroy, signal, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatOptionModule} from "@angular/material/core"
import {MatInputModule} from "@angular/material/input"
import {MatSelect} from "@angular/material/select"
import {LoadingSpinnerIconComponent} from "@app/common/components/progress"
import {
    defaultExportEngine,
    defaultExportFormat,
    defaultExportNormalY,
    defaultExportResolution,
    defaultExportWorkflow,
} from "@app/common/helpers/material-maps-exporter"
import {PbrExport, MaterialMapsExporterCore} from "@cm/material-maps-exporter"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-output-custom-pbr-export-form",
    imports: [FormsModule, LoadingSpinnerIconComponent, MatInputModule, MatOptionModule, MatSelect, UpperCasePipe],
    templateUrl: "./material-output-custom-pbr-export-form.component.html",
    styleUrl: "./material-output-custom-pbr-export-form.component.scss",
})
export class MaterialOutputCustomPbrExportFormComponent implements OnDestroy {
    readonly $onSubmit = input.required<(conversionRequest: PbrExport.Types.ConversionRequest) => Promise<void>>({alias: "onSubmit"})

    readonly $selectedExportWorkflow = signal(defaultExportWorkflow)
    readonly $selectedExportEngine = signal(defaultExportEngine)
    readonly $selectedExportNormalY = signal(defaultExportNormalY)
    readonly $selectedExportFormat = signal(defaultExportFormat)
    readonly $selectedExportResolution = signal(defaultExportResolution)
    exportWorkflows = PbrExport.Types.workflows
    exportEngines = PbrExport.Types.engines
    exportNormalsY = MaterialMapsExporterCore.Types.normalsY
    exportFormats = MaterialMapsExporterCore.Types.formats
    exportResolutions = MaterialMapsExporterCore.Types.resolutions

    readonly $isLoading = signal(false)
    timeout?: ReturnType<typeof setTimeout>

    async submit() {
        clearTimeout(this.timeout)
        this.$isLoading.set(true)
        const conversionRequest_ = PbrExport.Config.conversionRequest(
            this.$selectedExportWorkflow(),
            this.$selectedExportEngine(),
            this.$selectedExportNormalY(),
            this.$selectedExportFormat(),
            this.$selectedExportResolution(),
        )
        await this.$onSubmit()(conversionRequest_)
        this.timeout = setTimeout(() => {
            this.$isLoading.set(false)
        }, 300)
    }

    ngOnDestroy() {
        clearTimeout(this.timeout)
    }

    protected readonly workflowToString = PbrExport.Utils.workflowToString
    protected readonly engineToString = PbrExport.Utils.engineToString
    protected readonly normalYToString = PbrExport.Utils.normalYToString
    protected readonly resolutionToString = PbrExport.Utils.resolutionToString
}
